export default class LoansRoutingService {

  constructor($transitions) {
    'ngInject';
    this.transitions = $transitions;
  }

}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRouting/loansRouting.service.js